import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { VehicleApiService } from 'src/app/core/services/mobile-api/vehicle-api/vehicle-api.service';
import { LoanApplicationService } from 'src/app/core/services/loan-application/loan-application.service';

@Component({
	selector: 'op-spl-product-offer-info-card',
	templateUrl: './spl-product-offer-info-card.component.html',
	styleUrls: ['./spl-product-offer-info-card.component.scss']
})
export class SplProductOfferInfoCardComponent implements OnInit {
	@Input()
	showSkipSPLOfferButton: boolean;

	@Input()
	skipOfferButtonText: string;

	@Input()
	splMaxLoanAmount: number;

	@Input()
	showSPLDocSection: boolean;

	@Output()
	continue = new EventEmitter<any>();

	vehicleInfo: {
		make?: string;
		model?: string;
		year?: string | number;
		trim?: string;
		vinLast5?: string;
	} = {};

	constructor(private vehicleApiService: VehicleApiService, private loanAppService: LoanApplicationService) {}

	ngOnInit(): void {
		const loanId = this.loanAppService.loanApplicationId;
		const applicantIndex = this.loanAppService.getCurrentApplicantUtils()?.getCurrentApplicantIndex();
		this.vehicleApiService.getVehicle(loanId, applicantIndex).subscribe({
			next: (vehicle) => {
				if (vehicle) {
					this.vehicleInfo = {
						make: vehicle.makeStr,
						model: vehicle.modelStr,
						year: vehicle.year,
						trim: vehicle.trimStr,
						vinLast5: vehicle.vin ? vehicle.vin.slice(-5) : undefined
					};
				}
			}
		});
	}

	onContinue(): void {
		this.continue.emit();
	}
}
